import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getClients } from '../../services/api';
import { Badge, Card, Spinner } from '../../components/shared/UI';

function Stat({ icon, label, value, color }) {
  return (
    <div style={{ background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:16,padding:'20px 22px',display:'flex',alignItems:'center',gap:16 }}>
      <div style={{ width:48,height:48,background:`${color}22`,borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0 }}>{icon}</div>
      <div>
        <div style={{ color:'rgba(255,255,255,0.42)',fontSize:12,fontWeight:500,textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:4 }}>{label}</div>
        <div style={{ color:'#fff',fontSize:28,fontWeight:700,fontFamily:"'Syne',sans-serif",lineHeight:1 }}>{value}</div>
      </div>
    </div>
  );
}

function clientStatus(c) {
  if (!c.active) return { label:'Inactivo', color:'red' };
  if (c.expiresAt && new Date(c.expiresAt) < new Date()) return { label:'Vencido', color:'yellow' };
  return { label:'Activo', color:'green' };
}

export default function AdminDashboard() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getClients()
      .then(setClients)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const active   = clients.filter(c => c.active && (!c.expiresAt || new Date(c.expiresAt) > new Date())).length;
  const inactive = clients.filter(c => !c.active).length;
  const expired  = clients.filter(c => c.active && c.expiresAt && new Date(c.expiresAt) < new Date()).length;

  return (
    <div>
      <div style={{ marginBottom:28 }}>
        <h1 style={{ color:'#fff',fontSize:26,fontFamily:"'Syne',sans-serif",fontWeight:800,margin:'0 0 6px' }}>Panel de Control</h1>
        <p style={{ color:'rgba(255,255,255,0.38)',fontSize:14,margin:0 }}>Resumen general del sistema</p>
      </div>

      {loading ? (
        <div style={{ display:'flex',justifyContent:'center',padding:60 }}><Spinner /></div>
      ) : (
        <>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:14,marginBottom:28 }}>
            <Stat icon="👥" label="Total clientes"  value={clients.length} color="#7c3aed" />
            <Stat icon="✅" label="Activos"          value={active}         color="#22c55e" />
            <Stat icon="⛔" label="Inactivos"        value={inactive}       color="#ef4444" />
            <Stat icon="⏰" label="Vencidos"         value={expired}        color="#eab308" />
          </div>

          <Card>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20,flexWrap:'wrap',gap:10 }}>
              <h2 style={{ color:'#fff',fontSize:16,fontWeight:600,margin:0 }}>Clientes recientes</h2>
              <Link to="/admin/clients" style={{ color:'#a78bfa',fontSize:13,textDecoration:'none',fontWeight:500 }}>Ver todos →</Link>
            </div>

            {clients.length === 0 ? (
              <p style={{ color:'rgba(255,255,255,0.3)',fontSize:14,textAlign:'center',padding:'28px 0' }}>
                Todavía no hay clientes. <Link to="/admin/clients" style={{ color:'#a78bfa' }}>Creá el primero →</Link>
              </p>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%',borderCollapse:'collapse' }}>
                  <thead>
                    <tr>
                      {['Usuario','Estado','Vencimiento','Creado'].map(h => (
                        <th key={h} style={{ padding:'10px 16px',textAlign:'left',color:'rgba(255,255,255,0.38)',fontSize:12,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.05em',borderBottom:'1px solid rgba(255,255,255,0.07)' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {clients.slice(0, 8).map(c => {
                      const st = clientStatus(c);
                      return (
                        <tr key={c.id} style={{ borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                          <td style={{ padding:'13px 16px',color:'#fff',fontSize:14,fontWeight:500 }}>{c.username}</td>
                          <td style={{ padding:'13px 16px' }}><Badge color={st.color}>{st.label}</Badge></td>
                          <td style={{ padding:'13px 16px',color:'rgba(255,255,255,0.45)',fontSize:13 }}>
                            {c.expiresAt ? new Date(c.expiresAt).toLocaleDateString('es-AR') : '—'}
                          </td>
                          <td style={{ padding:'13px 16px',color:'rgba(255,255,255,0.38)',fontSize:13 }}>
                            {new Date(c.createdAt).toLocaleDateString('es-AR')}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </Card>
        </>
      )}
    </div>
  );
}
